module.exports = __webpack_public_path__ + "static/media/new_wps_3.cef1d8f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/new_wps_3.jpg
// module id = 1903
// module chunks = 0